namespace GeniuzPOS.Purchase {
    export interface ImportPrForm {
        Date: Serenity.DateEditor;
        FileName: Serenity.ImageUploadEditor;
    }

    export class ImportPrForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ImportPrForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ImportPrForm.init)  {
                ImportPrForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.ImageUploadEditor;

                Q.initFormType(ImportPrForm, [
                    'Date', w0,
                    'FileName', w1
                ]);
            }
        }
    }
}
